import { FC } from 'react';
import { Image } from 'react-bootstrap';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination } from 'swiper/modules';
import 'swiper/css/pagination';
import { OnlineshopProductImages } from '../../../../../../../../Interface/OnlineshopProductImages';
import QuickViewImageBadges, {
  QuickViewImageBadgesProps,
} from './QuickViewImageBadges';
import styles from './ProductQuickViewModal.module.scss?module';

interface QuickViewMobileGalleryProps {
  images: OnlineshopProductImages;
  badgesProps: QuickViewImageBadgesProps;
}

const QuickViewMobileGallery: FC<QuickViewMobileGalleryProps> = ({
  images,
  badgesProps,
}) => {
  const allImages = [
    images.front_image_url,
    images.nutrition_facts_image_url,
    ...(images.sell_sheets.map((item) => item.image_url) ?? []),
  ].filter((src): src is string => !!src && src.length > 0);

  return (
    <div className={styles.MobileSwiperContainer}>
      <QuickViewImageBadges {...badgesProps} />
      <Swiper
        navigation={false}
        pagination={{ clickable: true }}
        spaceBetween={5}
        modules={[Pagination]}
        autoHeight
      >
        {allImages.map((src, ind) => (
          <SwiperSlide key={ind}>
            <Image width="100%" src={src} />
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default QuickViewMobileGallery;
